module.exports = __webpack_public_path__ + "static/media/M64ws.90a7367d.pdf";